<template>
  <div class="overflow-auto h-full">
    <div class="mobile-status-padding"></div>
    <!-- <div
      class="absolute w-full h-screen top-0 left-0 opacity-60"
      style="
        background: radial-gradient(
          circle at 5rem 5rem,
          #ffd2ab,
          transparent 30%
        );
      "
    ></div> -->
    <div class="relative">
      <div class="p-4 font-bold text-3xl title-color">Mes commandes</div>
      <!-- <div class="py-4"></div> -->

      <OrdersList
        @itemClick="
          el => {
            GEvents.dispatch('ordder_detail_view_request', el)
            // $refs.orderDetails.showDetails(el);
          }
        "
      />
      <div class="py-24"></div>
    </div>
  </div>
</template>

<script setup>
import OrdersList from '../components/OrdersList.vue'

import { ref } from 'vue'

const GEvents = {
  dispatch(eventName, data) {
    window.$bus?.emit(eventName, data)
  }
}
</script>
